import React from 'react';
import { Link } from 'react-router-dom';
import backgroundImage from '../assets/background.jpg'; // Adjust the path based on your folder structure
import { motion } from "framer-motion";
import CountUp from 'react-countup';
import companyImage from '../assets/about1.png'; 
import about from '../assets/about2.avif';
import { FaUsers, FaArrowUp, FaHandHoldingHeart } from 'react-icons/fa'; // Importing icons

const About = () => {
  return (
    <div>
      {/* Hero Section */}
      <div
        className="flex flex-col items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          height: '50vh',
        }}
      >
        <div className="flex flex-col items-center justify-center text-center py-10">
          <h6 className="text-xl font-normal text-white">Gravionix technologies</h6>
          <h1 className="text-5xl font-bold text-white">About Us</h1>
        </div>

        <div className="mt-8">
  <nav className="flex space-x-6">
    <Link to="/" className="text-lg text-blue-500 hover:text-blue-700">
      Home
    </Link>
    <span className="text-lg text-blue-500">/</span> {/* Dash between links */}
    <Link to="/about" className="text-lg text-blue-500 hover:text-blue-700">
      About
    </Link>
  </nav>
</div>
      </div>


      {/* About Our Company Section */}
      <section className="bg-gray-100 py-16">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            {/* Left Side: Text */}
            <div>
              <h6 className="text-xl font-normal mb-4 text-blue-800">About Our Company</h6>
              <h2 className="text-3xl font-bold mb-4">Driving Digital Transformation with Gravionix technologies</h2>
              <p className="text-lg text-gray-700 mb-6">
              Gravionix technologies is dedicated to providing cutting-edge technology and IT solutions to help businesses
                achieve their goals. We specialize in offering tailored IT services that optimize efficiency, productivity,
                and growth. With a passion for innovation, we empower businesses to thrive in the digital era.
              </p>
              <p className="text-lg text-gray-700 mb-6">
                Our team consists of skilled professionals who are committed to delivering results-driven solutions that
                foster growth and innovation. Whether you need IT consultancy, custom software development, or digital
                transformation, Gravionix technologies is here to help you succeed.
              </p>
              <a
                href="about"
                className="inline-block bg-blue-800 text-white py-3 px-8 rounded-full hover:bg-slate-950 hover:text-white transition"
              >
                Learn More
              </a>
            </div>

            {/* Right Side: Image and Stats */}
            <div className="mt-8 md:mt-0">
              <img
                src={companyImage}
                alt="Company"
                className="w-full h-auto rounded-lg shadow-lg mb-6"
              />
              <div className="text-lg text-gray-700">
                <h3 className="text-2xl font-semibold mb-6 text-blue-800">Our Achievements</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 text-center">
                  <div className="p-6 bg-white border-2 border-blue-500 rounded-full shadow-lg transform transition hover:scale-105 hover:shadow-2xl">
                    <h4 className="text-4xl font-bold text-blue-700 mb-2">
                      <CountUp start={0} end={129} duration={2} separator="," />
                      <span className="text-xl">+</span>
                    </h4>
                    <p className="text-gray-600">Projects Completed</p>
                  </div>
                  <div className="p-6 bg-white border-2 border-green-500 rounded-full shadow-lg transform transition hover:scale-105 hover:shadow-2xl">
                    <h4 className="text-4xl font-bold text-green-700 mb-2">
                      <CountUp start={0} end={50} duration={2} separator="," />
                      <span className="text-xl">+</span>
                    </h4>
                    <p className="text-gray-600">Happy Customers</p>
                  </div>
                  <div className="p-6 bg-white border-2 border-yellow-500 rounded-full shadow-lg transform transition hover:scale-105 hover:shadow-2xl">
                    <h4 className="text-4xl font-bold text-yellow-700 mb-2">
                      <CountUp start={0} end={30} duration={2} separator="," />
                      <span className="text-xl">+</span>
                    </h4>
                    <p className="text-gray-600">Awards & Recognition</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-gray-50 py-20">
  <div className="container mx-auto px-4">
    <h3 className="text-3xl font-bold text-center text-blue-900 mb-4">Our Milestones</h3>

    {/* New paragraph under the heading */}
    <p className="text-lg text-gray-700 text-center mb-12">
      At Gravionix technologies, every milestone represents a significant achievement that has shaped our journey. From our humble beginnings to becoming a global player, each step has been a testament to our commitment to innovation and excellence.
    </p>

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12 justify-items-center">
      {/* Milestone 1 */}
      <motion.div 
        className="w-full sm:w-72 lg:w-80 h-full sm:h-72 lg:h-80 bg-white border-4 border-blue-500 rounded-full shadow-lg flex items-center justify-center"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, delay: 0.3 }}
        whileHover={{ scale: 1.1, rotate: 12 }}
        whileTap={{ scale: 0.95 }}
      >
        <div className="text-center px-4">
          <h4 className="text-2xl sm:text-3xl font-semibold text-blue-800 mb-4">Founded</h4>
          <p className="text-sm sm:text-lg text-gray-700">Gravionix technologies was founded in 2015 with a vision to revolutionize the tech industry.</p>
          <span className="text-sm sm:text-base text-gray-500">January 2015</span>
        </div>
      </motion.div>

      {/* Milestone 2 */}
      <motion.div 
        className="w-full sm:w-72 lg:w-80 h-full sm:h-72 lg:h-80 bg-white border-4 border-green-500 rounded-full shadow-lg flex items-center justify-center"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, delay: 0.5 }}
        whileHover={{ scale: 1.1, rotate: 12 }}
        whileTap={{ scale: 0.95 }}
      >
        <div className="text-center px-4">
          <h4 className="text-2xl sm:text-3xl font-semibold text-blue-800 mb-4">First Project</h4>
          <p className="text-sm sm:text-lg text-gray-700">Our first big project was with Corplyxtechnology, where we provided IT solution.</p>
          <span className="text-sm sm:text-base text-gray-500">July 2016</span>
        </div>
      </motion.div>

      {/* Milestone 3 */}
      <motion.div 
        className="w-full sm:w-72 lg:w-80 h-full sm:h-72 lg:h-80 bg-white border-4 border-yellow-500 rounded-full shadow-lg flex items-center justify-center"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, delay: 0.7 }}
        whileHover={{ scale: 1.1, rotate: 12 }}
        whileTap={{ scale: 0.95 }}
      >
        <div className="text-center px-4">
          <h4 className="text-2xl sm:text-3xl font-semibold text-blue-800 mb-4">Global Expansion</h4>
          <p className="text-sm sm:text-lg text-gray-700">We expanded globally in 2019, opening offices in Europe  to our growing international client.</p>
          <span className="text-sm sm:text-base text-gray-500">March 2019</span>
        </div>
      </motion.div>
    </div>
  </div>
</section>


 {/* Second Container: About Information with Image */}
 <div className="flex flex-col lg:flex-row items-center justify-between gap-8 px-6 sm:px-12 bg-gray-100 pt-16 pb-16">
        {/* Left Section: Text Description */}
        <motion.div
          className="flex-1"
          initial={{ opacity: 0, x: -100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        >
          <h3 className="text-3xl sm:text-3xl font-bold text-blue-900 mb-4">
            Our Vision
          </h3>
          <p className="text-lg text-gray-800 mb-6">
            Our vision is to help businesses unlock their potential by providing cutting-edge technology solutions, personalized services, and unwavering support throughout their journey.
          </p>

          {/* Additional Paragraphs */}
          <p className="text-lg text-gray-800 mb-6">
            We strive to foster a culture of collaboration, where our team works closely with our clients to understand their unique challenges and goals. By leveraging the power of technology, we aim to provide scalable solutions that are future-proof, cost-effective, and efficient.
          </p>
          
          <p className="text-lg text-gray-800 mb-6">
            At the heart of our vision is the belief that technology should empower businesses to thrive. Our goal is to be a trusted partner, helping organizations adapt to an ever-changing digital landscape. We want to ensure that our clients are equipped with the right tools to make data-driven decisions and remain competitive in their industries.
          </p>
          
          
        </motion.div>

        {/* Right Section: Image */}
        <motion.div
          className="flex-1"
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        >
          <img
            src={about} // Ensure the image path is correct
            alt="About Us"
            className="w-full h-auto sm:h-80 lg:h-[400px] object-cover rounded-xl shadow-lg"
          />
        </motion.div>
      </div>

 {/* Third Container: Key Points */}
<div className="mt-16 px-6 sm:px-12 pb-8">
  <h2 className="text-3xl sm:text-4xl font-bold text-center text-blue-900 mb-4">
    Our Core Values
  </h2>

  {/* 2–3 Line Paragraph Below Heading */}
  <p className="text-center text-sm  sm:text-xl text-gray-700 mb-12">
    At the heart of our company are values that foster innovation, growth, and a commitment to our customers. 
    We strive to maintain an environment where excellence thrives, ensuring that we deliver the best solutions for your business.
  </p>

  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12">
    {/* Key Point 1 */}
    <motion.div
      className="bg-cyan-700 text-white p-8 rounded-xl shadow-xl hover:shadow-2xl transition-transform duration-300 ease-in-out"
      whileHover={{ scale: 1.05 }}
    >
      <div className="flex items-center mb-4">
        <FaUsers size={32} className="mr-4" />
        <h4 className="text-xl sm:text-2xl font-semibold">
          Passionate Team
        </h4>
      </div>
      <p>
        Our team is made up of experts who are passionate about technology and helping your business grow.
      </p>
    </motion.div>

    {/* Key Point 2 */}
    <motion.div
      className="bg-cyan-700 text-white p-8 rounded-xl shadow-xl hover:shadow-2xl transition-transform duration-300 ease-in-out"
      whileHover={{ scale: 1.05 }}
    >
      <div className="flex items-center mb-4">
        <FaArrowUp size={32} className="mr-4" />
        <h4 className="text-xl sm:text-2xl font-semibold">
          Scalable Growth
        </h4>
      </div>
      <p>
        Our scalable solutions are designed to grow with your business, ensuring long-term success as your needs evolve.
      </p>
    </motion.div>

    {/* Key Point 3 */}
    <motion.div
      className="bg-cyan-700 text-white p-8 rounded-xl shadow-xl hover:shadow-2xl transition-transform duration-300 ease-in-out"
      whileHover={{ scale: 1.05 }}
    >
      <div className="flex items-center mb-4">
        <FaHandHoldingHeart size={32} className="mr-4" />
        <h4 className="text-xl sm:text-2xl font-semibold">
          Customer Focus
        </h4>
      </div>
      <p>
        We place our clients at the center of everything we do, ensuring their satisfaction and success.
      </p>
    </motion.div>
  </div>
</div>


    </div>
  );
};

export default About;
